import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSharedBetsData } from '@core/Areas/FollowMe/hooks/useSharedBetsData'
import { EmptyFeedMessage } from '@core/Areas/FollowMe/Components/Common/EmptyFeedMessage'
import type { SortOrder, SortFilter } from '@core/Areas/FollowMe/types'
import { SortFeed } from '@core/Areas/FollowMe/Components/Common/SortFeed'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { FeedContainerStyled } from '@core/Areas/FollowMe/Components/Common/FollowMe.styles'
import { PullToRefreshContainer } from '@mobi/component-library/Common/PullToRefreshContainer'
import { SkeletonLoader } from '../Common/SkeletonLoader'
import { followMeFollowingProfilesQuery } from '../../helpers/queries'
import { NewFeedPostsManager } from '../Common/NewFeedPostsManager'

let sessionSortOrder: SortOrder = 'sortAsc'
let sessionSortFilder: SortFilter = 'JumpTime'

export const FollowingFeed = () => {
  const [sortOrder, setSortOrder] = React.useState<SortOrder>(sessionSortOrder)
  const [sortFilter, setSortFilter] = React.useState<SortFilter>(sessionSortFilder)

  React.useEffect(() => {
    sessionSortOrder = sortOrder
    sessionSortFilder = sortFilter
  }, [sortFilter, sortOrder])

  const { data: followingAccounts, isLoading: isLoadingFollowingAccounts } = useQuery(
    followMeFollowingProfilesQuery
  )

  const { isLoading, data, isRefetching, refetch, LoadMoreButton, firstPostSeenId } =
    useSharedBetsData({
      sortFilter,
      sortOrder,
      isFollowing: true,
    })

  if (followingAccounts?.length === 0) {
    return (
      <EmptyFeedMessage
        title='Welcome to your Following Feed!'
        description={`Your feed gives easy access to\n Tips from Profiles you follow.`}
      />
    )
  }

  if (!isLoading && data?.pages && (data.pages.length === 0 || data.pages[0].length === 0)) {
    return (
      <EmptyFeedMessage
        title='No tips from the profiles you follow'
        description={`Check back later or explore other\n tipsters to see the latest picks.`}
      />
    )
  }

  return (
    <>
      <SortFeed
        sortFilter={sortFilter}
        sortOrder={sortOrder}
        handleSortFilterChange={setSortFilter}
        handleSortOrderChange={setSortOrder}
      />

      {!data || isLoading || isRefetching || isLoadingFollowingAccounts ? (
        <SkeletonLoader />
      ) : (
        <PullToRefreshContainer onRefresh={refetch}>
          <FeedContainerStyled>
            <NewFeedPostsManager
              fromPostId={firstPostSeenId}
              sortOrder={sortOrder}
              sortFilter={sortFilter}
            />

            {data.pages.map(feedPage =>
              feedPage.map(sharedBet => (
                <SharedBetCard key={sharedBet.postId} sharedBet={sharedBet} />
              ))
            )}

            <LoadMoreButton />
          </FeedContainerStyled>
        </PullToRefreshContainer>
      )}
    </>
  )
}
